import { Refresh } from "@mui/icons-material";
import { Box, Button, Snackbar } from "@mui/material";
import { memo } from "react";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { useCheckNewProjectVersion } from "features/render/hooks/useCheckNewProjectVersion";
import { useRefreshAndRestoreState } from "hooks/useRefreshAndRestoreState";
import { selectNewProjectVersionStatus } from "slices/explorer";
import { explorerActions } from "slices/explorer";

export default memo(function NewProjectVersionSnackbar() {
    const { t } = useTranslation();
    const newProjectVersionStatus = useAppSelector(selectNewProjectVersionStatus);
    const show = newProjectVersionStatus.available && !newProjectVersionStatus.dismissed;

    useCheckNewProjectVersion();

    const dispatch = useAppDispatch();

    const refresh = useRefreshAndRestoreState();

    const onClose = () => {
        dispatch(explorerActions.setNewProjectVersionStatus({ available: true, dismissed: true }));
    };

    if (!show) {
        return null;
    }

    return (
        <Snackbar
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            sx={{
                width: { xs: "auto", sm: 350 },
                bottom: { xs: "auto", sm: 88 },
                top: { xs: 24, sm: "auto" },
                pointerEvents: "auto",
            }}
            open={true}
            onClose={(_, reason) => {
                if (reason === "clickaway") {
                    return;
                }
                onClose();
            }}
            message={t("newProjectVersionMessage")}
            action={
                <Box display="flex" alignItems="center" gap={1}>
                    <Button
                        color="primary"
                        size="small"
                        variant="contained"
                        type="button"
                        onClick={refresh}
                        startIcon={<Refresh />}
                    >
                        {t("refresh")}
                    </Button>
                    <Button color="primary" size="small" variant="text" type="button" onClick={onClose}>
                        {t("dismiss")}
                    </Button>
                </Box>
            }
        />
    );
});
